
	var $ = require('@alife/alpha-jquery/jquery');
	
	// Buttons
	// 提供buttons配置的支持
	// ---------------------
	// Thanks to:
	//  - http://yuilibrary.com/yui/docs/api/classes/WidgetButtons.html
	
	// 增加效率，防止多次运行
	exports._buttons = null;
	
	/**
	 * 初始化buttons
	 * 1. dom事件
	 * 2. 自定义事件
	 *
	 * @method _setupButtons
	 * @protected
	 */
	exports._setupButtons = function(){
		var buttons = this.get('buttons'),
			buttonMap = this.get('buttonMap'),
			button, fn,
			i, l;
		
		for(i = 0, l = buttons.length; i < l; i++){
			button = buttons[i];
			fn = button.action;
			
			if(isString(fn)){
				fn = this[fn];
			}
			
			// 绑定dom事件
			if(isFunction(fn)){
				this.delegateEvents('click [data-role=' + button.name + ']', fn);
			}
			
			// 绑定自定义事件
			//this.delegateEvents('click [data-role=' + button.name + ']', this._handleButton);
		}
	};
	
	/**
	 * 自定义按钮触发自定义事件的handle
	 *
	 * @method _handleButton
	 * @private
	 */
	/*exports._handleButton = function(ev){
		ev.preventDefault();
		this.trigger($(ev.currentTarget).data('role'));
	};*/
	
	/**
	 * 格式化buttons属性
	 *
	 * @method _convertButtons
	 * @param buttons {Array} 用户配置的button属性数组
	 * @param buttons[0] {String|Object} string表示用默认的按钮，object用的是自定义按钮
	 * @param buttons[0].name {String} 按钮类型，影响触发的事件及对应的data-role
	 * @param buttons[0].html {String} 按钮的template
	 * @param buttons[0].action {String|Function} 按钮点击后触发的事件
	 * @return {Array} 格式化好的buttons属性
	 * @private
	 */
	exports._convertButtons = function(buttons){
		var i, l, button, name,
			buttonMap = this.get('buttonMap'),
			ret = [];
		
		buttons = buttons || [];
		
		for(i = 0, l = buttons.length; i < l; i++){
			button = buttons[i];
			
			// 如果是String，表示用默认的buttons
			if(isString(button)){
				if(buttonMap[button]){
					ret[i] = {
						name: button,
						html: buttonMap[button]
					};
				} else {
					throw new Error(button + ' is not default button!');
				}
			} else {
				// 如果是Object，添加
				if(isObject(button)){
					name = button.name;
					
					// 如果是默认的buttons的name，做merge
					if(buttonMap[name]){
						button = $.extend({
							name: name,
							html: buttonMap[name]
						}, button);
					}
					
					// 如果html没有加data-role，在这里追加，用最简单粗暴的方式
					if(button.html.indexOf('data-role') === -1){
						button.html = button.html.replace('>', ' data-role="' + button.name + '">');
					}
					
					ret[i] = button;
				} else {
					// 其他类型，报错
					throw new Error('buttons[' + i + '] is invalid!');
				}
			}
		}
		
		return ret;
	};
	
	//-----------Helper
	
	var toString = Object.prototype.toString;
	
	function isString(val){
		return toString.call(val) === '[object String]';
	}
	
	function isFunction(val) {
		return toString.call(val) === '[object Function]';
	}
	
	function isObject(val){
		return val && typeof val === 'object';
	}
